/**
 * ExtrasSection
 * Sección de contenido extra del capítulo
 */
import React, { memo } from "react";
import { motion } from "framer-motion";
import { Trans } from "react-i18next";
import ExtraViewer from "./ExtraViewer";
import CloseButton from "../../shared/components/CloseButton";

const ExtrasSection = ({ currentSection, chapterTitle, extraData }) => {
    return (
        <motion.div
            key={`${currentSection}-extras`}
            className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-90"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            style={{ overflow: "hidden" }}
        >
            <CloseButton />
            <h1 className="text-3xl font-bold text-white mb-4 text-center">
                <Trans i18nKey="extras" />: {chapterTitle}
            </h1>
            <ExtraViewer extraData={extraData} />
        </motion.div>
    );
};

export default memo(ExtrasSection);
